import { Navigate, useRoutes } from 'react-router-dom';

// import { protectedRoutes } from './protected';
import { publicRoutes } from './public';
import ReceptionForm from '@/features/reception-form/ReceptionForm';

export const AppRoutes = () => {
  const commonRoutes = [
    { path: '/reception-form', element: <ReceptionForm /> },
    { path: '/*', element: <Navigate to="/reception-form" /> }
  ];

  // TODO: AWSのAuthでログイン状態を判定
  // const routes = auth.user ? protectedRoutes : publicRoutes;
  const routes = publicRoutes;

  return useRoutes([...routes, ...commonRoutes]);
};

export default AppRoutes;
